import * as THREE from 'three';
import { useGLTF, useTexture } from '@react-three/drei';
import { forwardRef, useMemo, useImperativeHandle } from 'react';

const Batteries = forwardRef(({ isActive, opacity=1 }, ref) => {
    const batteriesGltf = useGLTF('./models/truck/batteries.glb');
    const batteriesTexture = useTexture('./textures/truck/batteries.jpg');
    batteriesTexture.flipY = false;

    const materials = useMemo(() => {
        const glowBlue = new THREE.MeshBasicMaterial({
            color: new THREE.Color(0, 0.3, 20),
            toneMapped: false,
            transparent: true,
            opacity: opacity,
        });

        const baseMaterial = new THREE.MeshBasicMaterial({
            map: batteriesTexture,
            transparent: true,
            opacity: opacity,
        });

        return { glowBlue, baseMaterial };
    }, [batteriesTexture, opacity]);

    const material = isActive ? materials.glowBlue : materials.baseMaterial;

    useImperativeHandle(ref, () => ({
        glowBlueMaterial: materials.glowBlue,
        baseMaterial: materials.baseMaterial,
    }));

    return (
        <>
            <mesh 
                geometry={batteriesGltf.nodes.batteries.geometry}
                onClick={(event) => event.stopPropagation()}
                onPointerEnter={(event) => event.stopPropagation()}
                ref={ref}
                renderOrder={2}
            >
                <primitive attach="material" object={material} />
            </mesh>
        </>
    );
});

export default Batteries;
